
// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function DataPointWidget({ color, name, value }) {
  return (
      <MDBox>
          <MDTypography variant="body2" color="text" fontWeight="medium">
            {name}
          </MDTypography>
          <MDTypography variant="body1"  fontWeight="bold">
            {value}
          </MDTypography>
      </MDBox>
  );
}

// Setting default values for the props of MiniInfoCard
DataPointWidget.defaultProps = {
  color: "info",
};

// Typechecking props for the MiniInfoCard
DataPointWidget.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  name: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
};

export default DataPointWidget;
